import { useCallback } from 'react';
import {
  SuccessCallback,
  useActionPipeline,
  useDialogState,
  useToast,
} from 'hooks';
import { useIntl } from 'react-intl';
import { commonTexts } from 'i18n';
import { changeStatus } from 'store/scorecards';
import { SCORECARD_ACTION_GOALS_APPROVE } from 'constants/scorecards';
import { useScorecardContext } from 'contexts';

export default function useApproveGoals() {
  const { id, store } = useScorecardContext();
  const [
    isApproveGoalsDialogActive,
    openApproveGoalsDialog,
    onApproveGoalsDialogClose,
  ] = useDialogState();

  const onApproveGoalsClick = useCallback(() => {
    openApproveGoalsDialog();
  }, [openApproveGoalsDialog]);

  const { formatMessage } = useIntl();
  const showMessage = useToast();
  const onApproveGoalsSuccess = useCallback<SuccessCallback>(() => {
    showMessage({
      severity: 'success',
      message: formatMessage(commonTexts.success),
    });
  }, [showMessage, formatMessage]);

  const approveGoalsPipeline = useActionPipeline(
    onApproveGoalsSuccess,
    null,
    onApproveGoalsDialogClose,
  );

  const onApproveGoalsSubmit = useCallback(() => {
    approveGoalsPipeline(
      changeStatus({
        id,
        store,
        action: SCORECARD_ACTION_GOALS_APPROVE,
      }),
    );
  }, [id, approveGoalsPipeline, store]);
  return {
    onApproveGoalsClick,
    isApproveGoalsDialogActive,
    onApproveGoalsDialogClose,
    onApproveGoalsSubmit,
  };
}
